import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/auth/Login.vue'
import Signup from '../views/auth/Signup.vue'
import Logout from '../views/auth/Logout.vue'
import Confirm from '../views/auth/Confirm.vue'
import Jobs from '../views/job/Jobs.vue'
import JobDetail from '../views/job/JobDetail.vue'
import JobForm from '../views/job/JobForm.vue'
import Organizations from '../views/organization/Organizations.vue'
import Staffs from '../views/staff/Staffs.vue'
import Users from '../views/user/Users.vue'
import News from '../views/news/News.vue'
import NewsForm from '../views/news/NewsForm.vue'
import NewsDetail from '../views/news/NewsDetail.vue'
import Payments from '../views/payment/Payments.vue'
import UserDetail from '../views/user/UserDetail.vue'
import Industries from '../views/industry/Industries.vue'
import IndustriesDetail from '../views/industry/IndustryDetail.vue'
import Questions from  '../views/question/Questions.vue'
import QuestionDetail from  '../views/question/QuestionDetail.vue'
import QuestionImport from  '../views/question/QuestionImport.vue'
import QuestionRadioImport from  '../views/question/QuestionRadioImport.vue'
import Examinations from '../views/examination/Examinations.vue'
import ExaminationDetail from '../views/examination/ExaminationDetail.vue'
import Places from  '../views/places/Places.vue'
import PlaceImport from  '../views/places/PlaceImport.vue'
import Partner from  '../views/partner/Partner.vue'
import Industry from  '../views/Industry.vue'
import LearningText from  '../views/LearningText.vue'
import PastExam from  '../views/PastExam.vue'
import Password from  '../views/auth/Password.vue'
import firebase from 'firebase'
import store from '.././store'
import Agencies from  '../views/agency/Agency.vue'
const TheContainer = () => import('@/containers/TheContainer')

Vue.use(VueRouter)

const requireAuth = async (to, from, next) => {
  console.log(to)
  console.log(to)
  await firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      firebase.auth().currentUser.getIdToken(true)
      .then(function(idToken) {
        store.commit('setIdToken', idToken)
        store.dispatch('fetchParter', idToken)
        next()
      }).catch(function() {

      });

    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  })

}

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: TheContainer,
    beforeEnter: requireAuth,
    children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Users
        },
        {
          path: 'news',
          name: 'news',
          component: News
        },
        {
          path: 'news/form',
          name: 'news',
          component: NewsForm
        },
        {
          path: 'news/:id/form',
          name: 'news',
          component: NewsForm
        },
        {
          path: 'news/:id',
          name: 'news',
          component: NewsDetail
        },
        {
          path: 'users',
          name: 'User',
          component: Users
        },
        {
          path: 'users/:id',
          name: "User",
          component: UserDetail
        },
        {
          path: 'payments',
          name: 'Payment',
          component: Payments
        },
        {
          path: 'industries',
          name: 'Industry',
          component: Industries
        },
        {
          path: 'industries/:id',
          name: 'Industry',
          component: IndustriesDetail
        },
        {
          path: 'questions',
          name: 'Question',
          component: Questions
        },
        {
          path: 'questions/:id',
          name: 'QuestionDetail',
          component: QuestionDetail
        },
        {
          path: 'question/import',
          name: 'QuestionImport',
          component: QuestionImport
        },
        {
          path: 'question/radio_import',
          name: 'QuestionRadioImport',
          component: QuestionRadioImport
        },
        {
          path: 'examinations',
          name: 'Examination',
          component: Examinations
        },
        {
          path: 'examination/:id',
          name: 'ExaminationDetail',
          component: ExaminationDetail
        },
        {
          path: 'jobs',
          name: 'Job',
          component: Jobs
        },
        {
          path: 'jobs/form',
          name: 'Job',
          component: JobForm
        },
        {
          path: 'jobs/:id/form',
          name: 'Job',
          component: JobForm
        },
        {
          path: 'jobs/:id',
          name: 'Job',
          component: JobDetail
        },
        {
          path: 'organizations',
          name: 'Organization',
          component: Organizations
        },
        {
          path: 'staffs',
          name: 'Staff',
          component: Staffs
        },
        {
          path: 'places',
          name: 'Place',
          component: Places
        },
        {
          path: 'place/import',
          name: 'PlaceImport',
          component: PlaceImport
        },
        {
          path: 'partner',
          name: 'Partner',
          component: Partner
        },
        {
          path: 'agency',
          name: 'Agency',
          component: Agencies
        },
        {
          path: 'industry/:id',
          name: 'Industry',
          component: Industry
        },
        {
          path: 'change_password',
          name: 'Password',
          component: Password
        },
        {
          path: 'learning_text',
          name: 'LearningText',
          component: LearningText
        },
        {
          path: 'past_exam',
          name: 'PastExam',
          component: PastExam
        },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: Confirm,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
